// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PBUYMDfl1CbB9ifRTwCi {
    background: none;
    border: none;
    box-shadow: none;
    padding: 5px;
}

.DVQNjSyuByp_g7Oe4dFc {
    width: 35px;
    height: 21px;
}`, "",{"version":3,"sources":["webpack://./src/components/LanguageSelection/LanguageSelection.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".button {\n    background: none;\n    border: none;\n    box-shadow: none;\n    padding: 5px;\n}\n\n.flag {\n    width: 35px;\n    height: 21px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `PBUYMDfl1CbB9ifRTwCi`,
	"flag": `DVQNjSyuByp_g7Oe4dFc`
};
export default ___CSS_LOADER_EXPORT___;
